import 'styles/tailwind.css';
import 'semantic-ui/semantic-ui-less.css';
import 'styles/styles.scss';
import 'styles/fonts.css';
import 'images/favicon.png';

// Node Modules
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Initializers
import * as I18nInitializer from 'initializers/i18n';
import * as AxiosLocaleInitializer from 'initializers/axiosLocale';
import * as AxiosSessionExpiryInitializer from 'initializers/axiosSessionExpiry';

// Pages and store configuration
import IndexPage from 'pages';
import store from 'store/config';

// Init Translations
I18nInitializer.init();

// Tell the API which language the UI is in, for responses rendered before login
AxiosLocaleInitializer.init();

// Redirect to login (with a session-expired message) on any API 401
AxiosSessionExpiryInitializer.init();

const container = document.getElementById('app-wrapper');
if (!container) {
  throw new Error('Root element #app-wrapper not found');
}

// Render Application
const root = createRoot(container);
const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <IndexPage />
    </Provider>
  </QueryClientProvider>
);
